export function drawShareCardImage(card) {
  const W = 1200;
  const H = 630;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#030712";
  ctx.fillRect(0, 0, W, H);

  const grad = ctx.createLinearGradient(0, 0, W, H);
  grad.addColorStop(0, "rgba(0,224,255,0.08)");
  grad.addColorStop(1, "rgba(0,255,163,0.05)");
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, W, H);

  ctx.strokeStyle = "rgba(0,224,255,0.35)";
  ctx.lineWidth = 3;
  ctx.strokeRect(24, 24, W - 48, H - 48);

  ctx.fillStyle = "#00E0FF";
  ctx.font = "bold 28px Arial";
  ctx.fillText("TRADEINSIGHTS AI", 64, 92);

  ctx.fillStyle = "#9CA3AF";
  ctx.font = "20px Arial";
  ctx.fillText(card.trading_style || "Trader", 64, 128);

  const streak = card.current_streak || 0;
  const isWin = card.streak_type === "win" && streak > 0;
  ctx.fillStyle = isWin ? "#00FFA3" : "#FFFFFF";
  ctx.font = "bold 96px Arial";
  const streakText = isWin ? `${streak} WIN STREAK` : `${card.win_rate}% WIN RATE`;
  ctx.fillText(streakText, 64, 260);

  if (isWin) {
    ctx.fillStyle = "#9CA3AF";
    ctx.font = "26px Arial";
    ctx.fillText(`Best run: ${card.max_win_streak} wins in a row`, 64, 308);
  }

  const stats = [
    { label: "WIN RATE", value: `${card.win_rate}%`, color: card.win_rate >= 50 ? "#00FFA3" : "#FF3B30" },
    { label: "TOTAL P&L", value: `$${card.total_pnl}`, color: card.total_pnl >= 0 ? "#00FFA3" : "#FF3B30" },
    { label: "RECORD", value: `${card.wins}W / ${card.losses}L`, color: "#FFFFFF" },
    { label: "GRADE", value: card.grade || "N/A", color: "#F59E0B" },
  ];
  stats.forEach((s, i) => {
    const x = 64 + i * 270;
    ctx.fillStyle = "rgba(255,255,255,0.04)";
    ctx.fillRect(x, 370, 240, 130);
    ctx.fillStyle = s.color;
    ctx.font = "bold 40px Arial";
    ctx.fillText(s.value, x + 24, 440);
    ctx.fillStyle = "#6B7280";
    ctx.font = "18px Arial";
    ctx.fillText(s.label, x + 24, 476);
  });

  ctx.fillStyle = "#6B7280";
  ctx.font = "20px Arial";
  ctx.fillText("AI-powered signals · not financial advice", 64, 572);
  ctx.fillStyle = "#00E0FF";
  ctx.textAlign = "right";
  ctx.fillText(window.location.host, W - 64, 572);
  ctx.textAlign = "left";

  return canvas.toDataURL("image/png");
}

export function downloadShareCard(card) {
  const url = drawShareCardImage(card);
  const a = document.createElement("a");
  a.href = url;
  a.download = `tradeinsights-streak-${card.share_id}.png`;
  a.click();
}
